// NO_MODIFY_THIS_FILE_BAKKA
import { activityActions } from '../../constants';

export const setActiveOption = (value) => ({
  type: activityActions.SET_ACTIVE_OPTION,
  payload: value,
});

export const setSelectedDuration = (value) => ({
  type: activityActions.SET_SELECTED_DURATION,
  payload: value,
});

export const setShowDisponibilities = (value) => ({
  type: activityActions.SET_SHOW_DISPONIBILITIES,
  payload: value,
});

export const setCourse = (value) => ({
  type: activityActions.SET_COURSE,
  payload: value,
});

export const setTypes = (value) => ({
  type: activityActions.SET_TYPES,
  payload: value,
});

export const setTypesFilters = (value) => ({
  type: activityActions.SET_TYPES_FILTERS,
  payload: value,
});

export const setError = (value) => ({
  type: activityActions.SET_ERROR,
  payload: value,
});

export const resetState = (value) => ({
  type: activityActions.RESET_STATE,
  payload: value,
});

export const setSelectedActivity = (value) => ({
  type: activityActions.SET_SELECTED_ACTIVITY,
  payload: value,
});
